export const getMapping = (mapperObj, key) => mapperObj[key] || "-";
